module.exports = __webpack_public_path__ + "static/media/los_angeles_team.31ec2e8c.jpg";